<template>
    <div>
        <van-action-sheet v-model="show" @close="close" @closed="closed">
            <div class="share">
                <h4>{{next === 1 ? '分享方式' : '分享到'}}</h4>
                <div class="share-content">
                    <template v-if="next === 1">
                        <div class="share-item" @click="next = 2">
                            <img src="@/assets/vipCoach/v2/icon_fxlj.png">
                            <div class="share-item__name">分享链接</div>
                        </div>
                        <div class="share-item" @click="handleJumpPage">
                            <img src="@/assets/vipCoach/v2/icon_schb.png">
                            <div class="share-item__name">生成海报</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="share-item" @click="handleShare('Wechat-Friends')">
                            <img src="@/assets/vipCoach/v2/icon_wxhy.png">
                            <div class="share-item__name">微信好友</div>
                        </div>
                        <div class="share-item" @click="handleShare('Wechat-Moments')">
                            <img src="@/assets/vipCoach/v2/icon_wxpyq.png">
                            <div class="share-item__name">微信朋友圈</div>
                        </div>
                    </template>
                </div>
                <van-button class="custom-btn" color="#F3F4FB" round block @click="handleCancel">取消</van-button>
            </div>
        </van-action-sheet>
        <SavePhoto v-if="info.backgroundPicUrl" ref="savePoster" :info="info"></SavePhoto>
    </div>
</template>
<script>
import { bindAppFn } from '../../utils'
import { ActionSheet, Button } from 'vant'
import SavePhoto from './savePhoto.vue'

export default {
    name: 'vipCoachShare',
    components: {
        [ActionSheet.name]: ActionSheet,
        [Button.name]: Button,
        SavePhoto
    },
    props: {
        // 是否多个商品
        isGoods: {
            type: Boolean,
            default: false
        },
        // 赚钱页 还是 海报页
        type: {
            type: String,
            default: 'money'
        },
        poster: {
            type: Object,
            default: null
        },
        subject: { // 对应的科目
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            show: false,
            next: 1,
            info: {}
        }
    },
    methods: {
        handleCancel () {
            this.show = false
        },
        // 跳转到分享海报
        handleJumpPage () {
            this.show = false
            this.$nextTick(() => {
                this.$router.push({
                    name: 'vipCoachPoster',
                    query: {
                        posterType: this.isGoods ? 1 : 0,
                        subject: this.subject
                    }
                })
            })
        },
        close () {
            if (this.type === 'money') {
                bindAppFn({
                    name: 'app',
                    data: {
                        method: 'showTabbar'
                    }
                })
            }
        },
        closed () {
            this.$emit('cancel')
        },
        /**
         * 分享
         * @param {String} type 分享类型 分享好友或朋友圈
         */
        handleShare (type) {
            // 如果是赚钱页面分享url 海报页面分享图片
            const shareType = this.type === 'money' ? 'url' : 'imageBase64'
            this.$refs['savePoster'].share(type, shareType, this.subject, this.isGoods)
            this.handleCancel()
        },
        getShareUrl () {
            const city = JSON.parse(localStorage.getItem('vipCoachCity'))
            this.$api.getCoachPoster({
                posterType: this.isGoods ? 1 : 0,
                cityCode: city.code,
                subject: this.subject
            }).then(({ result, status }) => {
                if (status) {
                    this.info = result
                }
            })
        }
    },
    mounted () {
        // 外部有海报则不需要重新请求
        if (!this.poster) {
            this.getShareUrl()
        } else {
            this.info = this.poster
        }
        this.show = true
        // 如果是赚钱页面 隐藏底部tab
        if (this.type === 'money') {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'hiddenTabbar'
                }
            })
        } else {
            this.next = 2
        }
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
.share{
    padding: 30px 0;
    color:#333;
    text-align: center;
    h4{
        font-size: 17px;
    }
    .share-content{
        margin-top: 26px;
        padding: 0 40px;
        display: flex;
        justify-content: space-around;
        .share-item{
            img{
                width: 50px;
                height: 50px;
            }
            div{
                margin-top: 10px;
                font-size: 13px;
            }
        }
    }
}
.custom-btn{
    margin: 30px auto 0 auto;
    width: 230px;
    height: 45px;
    line-height: 45px;
    color:#666 !important;
    font-size: 17px;
    font-weight: 600;
}
</style>
